// Cuerpo del paso 05 cuando la revisión del historial falla: reintentar o seguir de contado.
import { AlertTriangle, RotateCw } from 'lucide-react';
import { Button } from '@/kit';
import { SCORE_CONSULT_ERROR_COPY as COPY } from '../scoreConsultError';
import { ScreenIntro } from './KycScreenBits';

export function ScoreConsultErrorScreen({
    switchingToCash,
    onRetry,
    onContinueWithCash,
}: {
    switchingToCash: boolean;
    onRetry: () => void;
    onContinueWithCash: () => void;
}) {
    return (
        <div className="text-center">
            <ScreenIntro
                tone="warning"
                icon={<AlertTriangle className="size-7" aria-hidden />}
                title={COPY.title}
                sub={COPY.text}
            />
            <div className="flex flex-col items-center gap-2">
                <Button
                    disabled={switchingToCash}
                    leftIcon={<RotateCw className="size-3.5" aria-hidden />}
                    onClick={onRetry}
                >
                    {COPY.retryLabel}
                </Button>
                <Button variant="outline" isLoading={switchingToCash} onClick={onContinueWithCash}>
                    {COPY.cashLabel}
                </Button>
            </div>
            <p className="mt-3 text-[11.5px] text-muted-foreground">{COPY.cashHint}</p>
        </div>
    );
}
